import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './auth';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import '@fontsource-variable/geist';
import '@fontsource-variable/unbounded';
import './styles.css';
import './workspace.css';
import './experience.css';
import './polish/agency.css';
import './polish/work.css';
import './polish/client.css';
import './polish/content.css';
import './polish/setup.css';
import './polish/settings.css';
import './polish/ads.css';
import './polish/campaigns.css';
import './polish/ads-ai.css';
import './polish/facebook.css';
import './polish/competitors.css';
import './polish/keywords.css';
import './polish/shell.css';
import './polish/portfolio.css';
import './polish/library.css';
import './polish/tracking.css';
import './polish/crm.css';
import './polish/crm-booking.css';
import './polish/pages.css';
import './polish/date-range.css';
import './polish/portal.css';
import './polish/touch.css';
import { initializeAppearance } from './appearance';
import { watchTabStrips } from './tab-strips';

// Apply saved preferences before the first paint.
initializeAppearance();
// public/theme-boot.js painted the background before these styles existed; the app's own rules take over now.
document.documentElement.style.removeProperty('background');

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ErrorBoundary label="NOLA hit a problem">
          <App />
        </ErrorBoundary>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);

// Phone tab strips fade at the edge that hides more tabs (src/tab-strips.ts).
watchTabStrips();

// Installable app: the service worker only caches hashed assets and an offline page (web/public/sw.js).
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => { navigator.serviceWorker.register('/sw.js').catch(() => {}); });
}
